import { render, staticRenderFns } from "./EventPriceConfig.vue?vue&type=template&id=640c2cbc&"
import script from "./EventPriceConfig.vue?vue&type=script&lang=js&"
export * from "./EventPriceConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports